import { Images } from '../../../utils/imageConstants';
import { formatDateRange } from '../../../helper/helper';
import type { ITournament } from '../types/myTeam';

const formatShortDate = (iso: string): string => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'TBD';
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' }).format(d);
};

interface TournamentCardProps {
  tournament: ITournament;
  onClick?: (tournament: ITournament) => void;
}

function TournamentCard({ tournament, onClick }: TournamentCardProps) {
  const hasDates = tournament.startDate || tournament.endDate;
  const formattedRange = formatDateRange(tournament.startDate, tournament.endDate);
  const displayDates = hasDates
    ? formattedRange !== '-'
      ? formattedRange
      : `${tournament.startDate ? formatShortDate(tournament.startDate) : 'TBD'} - ${tournament.endDate ? formatShortDate(tournament.endDate) : 'TBD'}`
    : null;
  const displayLocation = tournament.location || 'TBD';
  const showPendingBadge = tournament.status?.toLowerCase() === 'pending';
  const isClickable = Boolean(onClick && tournament.teamSnapshotId);

  return (
    <div
      className={`myteam-tournament-card ${isClickable ? 'myteam-tournament-card--clickable' : ''}`}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={isClickable ? () => onClick?.(tournament) : undefined}
      onKeyDown={isClickable ? (e) => e.key === 'Enter' && onClick?.(tournament) : undefined}
    >
      {showPendingBadge && (
        <span className="myteam-tournament-badge pending">Pending</span>
      )}
      <div className="myteam-tournament-card-header">
        <h3 className="myteam-tournament-name">{tournament.tournamentName || 'Tournament'}</h3>
        {displayDates && (
          <span className="myteam-tournament-dates">{displayDates}</span>
        )}
      </div>
      <div className="myteam-tournament-card-footer">
        <div className="myteam-tournament-location">
          <img src={Images.location_card_icon} alt="" />
          <span>{displayLocation}</span>
        </div>
      </div>
    </div>
  );
}

export default TournamentCard;
